import PropTypes from "prop-types";
import React from "react";

export const Bags = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path
        d="M 8 18.51219512195122  L 8 6.7317073170731705  C 8.08450704225352 6.7317073170731705  0.8991283395863573 6.7317073170731705  0.8991283395863573 
   6.7317073170731705  C 0.4962865827379696 6.7317073170731705  0 7.194376852000135  0 7.5756736524532675  C 0 7.5756736524532675  0 17.671862656691168  
   0 17.671862656691168  C 0 18.051602084235707  0.4962865827379696 18.51219512195122  0.8991283395863573 18.51219512195122  C 0.8991283395863573 
   18.51219512195122  8.08450704225352 18.51219512195122  8 18.51219512195122  Z M 7.169691567672235 2.2439024390243905  C 6.756784409489008 2.2439024390243905  
   6.352112676056337 2.6120182331530444  6.352112676056337 2.9951298885373787  C 6.352112676056337 2.9951298885373787  6.352112676056337 5.609756097560975  
   6.352112676056337 5.609756097560975  L 8.201249512720775 5.609756097560975  L 8.201249512720775 3.9444331054189194  L 11.170404115461317 3.9190053406810232  L 13.74809206238646 3.9190053406810232  L 15.591549295774648 3.916788561191052  C 15.591549295774648 3.916788561191052  15.591549295774648 2.9951298885373787  15.591549295774648 2.9951298885373787  C 15.591549295774648 2.6120182331530444  15.188013482997228 2.2439024390243905  14.77468035456828 2.2439024390243905  C 14.77468035456828 2.2439024390243905  7.169691567672235 2.2439024390243905  7.169691567672235 2.2439024390243905  Z M 41 21.799400111478718  C 41 21.799400111478718  41 7.376387026161429  41 7.376387026161429  C 41 6.831567189036083  40.29876643797939 6.170731707317073  39.72377967139611 6.170731707317073  L 35.820030722285075 6.170731707317073  L 34.82559654166711 6.170731707317073  C 34.82559654166711 6.170731707317073  11.6663232897755 6.170731707317073  11.6663232897755 6.170731707317073  C 11.096562425399858 6.170731707317073  10.394366197183098 6.831567189036083  10.394366197183098 7.376387026161429  C 10.394366197183098 7.376387026161429  10.394366197183098 21.799400111478718  10.394366197183098 21.799400111478718  C 10.394366197183098 22.341886673070338  11.096562425399858 23  11.6663232897755 23  C 11.6663232897755 23  34.82559654166711 23  34.82559654166711 23  L 35.820030722285075 23  C 35.820030722285075 23  39.72377967139611 23  39.72377967139611 23  C 39.72377967139611 23  41 22.9640934820643  41 21.799400111478718  Z M 19.056338028169012 5.048780487804878  L 21.63652334879816 5.048780487804878  L 21.63652334879816 2.5127659321449363  L 25.68138904665462 2.5127659321449363  L 29.225833657566493 2.5127659321449363  L 29.225833657566493 5.048780487804878  L 31.76056338028169 5.048780487804878  C 31.76056338028169 5.048780487804878  31.76056338028169 1.1270112140419295  31.76056338028169 1.1270112140419295  C 31.76056338028169 0.5522231867857404  31.20567747781859 0  30.637277748948648 0  C 30.637277748948648 0  20.180442679284294 0  20.180442679284294 0  C 19.61272546689954 0  19.056338028169012 0.5522231867857404  19.056338028169012 1.1270112140419295  C 19.056338028169012 1.1270112140419295  19.056338028169012 5.048780487804878  19.056338028169012 5.048780487804878  Z "
      />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 -12 44 44",
    };
  }
};

Bags.displayName = "BagsIcon";

Bags.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Bags.defaultProps = { role: "img" };
